import { useContext, useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../../../../api/api.js';
import { isDemo, AppContext, WidgetsContext } from '../../../GlobalContex';
import useNotifications from '../../../hooks/useNotifications';
import { useAnalytics } from '../../../hooks/useAnalytics';

const YoutubeChannelConnectInput = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const [channel, setChannel] = useState('');
  const { activeWidget, setActiveWidgetSettings, activeWidgetMeta } = useContext(WidgetsContext);
  const { sendEvent } = useAnalytics();

  useEffect(() => {
    setChannel(activeWidget?.settings?.channel || '');
  }, [activeWidget?.id]);

  async function connectYoutubeChannel(channel) {
    try {
      const payload = await api.connectYoutubeChannel(
        activeWidgetMeta.connectChannelUrl || `apps/youtube-feed/widgets/${activeWidget.id}/data`,
        channel,
        { preview: isDemo }
      );
      sendEvent('connect_account', {
        account: 'youtube'
      });
      setActiveWidgetSettings(payload);
    } catch (err) {
      notification.error(err.message);
    }
  }

  function clickHandle() {
    connectYoutubeChannel(channel);
  }

  function changeHandle(e) {
    const { value } = e.target;
    setChannel(value);
  }

  return (
    <>
      <Form.Group className={'mb-3'}>
        <Form.Label className="mb-3">
          {t(`YouTube URL starting with:
            https://www.youtube.com/c/
            https://www.youtube.com/channel/
            https://www.youtube.com/user/
            https://www.youtube.com/@`)}
        </Form.Label>
        <Form.Control
          className="mb-3"
          as="textarea"
          value={channel}
          rows="3"
          onChange={changeHandle}
          placeholder="https://www.youtube.com/channel/UCsooa4yRKGN_zEE8iknghZA"
        />
      </Form.Group>
      <Form.Group>
        <Button className="w-100" variant="primary" onClick={clickHandle}>
          {t('Connect')}
        </Button>
      </Form.Group>
    </>
  );
};

export default YoutubeChannelConnectInput;